import ApiServices from "../../Utils/ApiServices/ApiServices";

class SignUpAccessToken {
  fetchAccessToken = async () => {
    try {
      const username = process.env.REACT_APP_PROVIDER_USERNAME;
      const password = process.env.REACT_APP_PROVIDER_PASSWORD;
      const UserRole = "users";
      const scope = process.env.REACT_APP_PROVIDER_SCOPES;

      const authResponse = await ApiServices.post(
        "/oauth2/default/token",
        {
          client_id: process.env.REACT_APP_CLINTID_ACS_TKN,
          grant_type: "password",
          scope: scope,
          user_role: UserRole,
          username: username,
          password: password,
          email: username,
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      );
      return authResponse.data.access_token;
    } catch (error) {
      console.error("Error fetching access token:", error);
      throw error;
    }
  };
}
export default new SignUpAccessToken();
